"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UICardHeader = _interopRequireDefault(require("./UICardHeader"));

var _UICardSection = _interopRequireDefault(require("./UICardSection"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _UIDragHandle = _interopRequireDefault(require("../draggable/UIDragHandle"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _AccordionTransition = _interopRequireDefault(require("../transitions/AccordionTransition"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _times = require("HubStyleTokens/times");

var TRANSITION_ANIMATION_TIMEOUT = parseInt(_times.CARD_TRANSITION_ANIMATION_TIMING, 10);

var isDraggable = function isDraggable(child) {
  return child.type.displayName === _UIDragHandle.default.displayName;
};

var isExpander = function isExpander(child) {
  var possibleHeader = child;

  if (_react.default.isValidElement(child) && isDraggable(child)) {
    possibleHeader = child.props.children;
  }

  return _react.default.isValidElement(possibleHeader) && possibleHeader.type === _UICardHeader.default;
};

var isSection = function isSection(child) {
  return _react.default.isValidElement(child) && child.type === _UICardSection.default;
};

var renderExpandableChildren = function renderExpandableChildren(children, expanded, onExpandedChange) {
  var sawHeader = false;

  var output = _react.Children.map(children, function (child) {
    if (isExpander(child)) {
      sawHeader = true;
      return _react.default.cloneElement(child, {
        expanded: expanded,
        onExpandedChange: onExpandedChange
      });
    }

    if (isSection(child)) {
      return _react.default.createElement(_AccordionTransition.default, {
        className: "private-card__content-wrapper",
        open: expanded,
        duration: TRANSITION_ANIMATION_TIMEOUT
      }, child);
    }

    return child;
  });

  if (!sawHeader) {
    var msg = 'UICardWrapper: Expandable behavior requires a UICardHeader child';

    _devLogger.default.warn({
      message: msg,
      key: msg
    });
  }

  return output;
};

var UICardWrapper = _react.default.createClass({
  displayName: "UICardWrapper",
  propTypes: (0, _extends2.default)({}, _UISection.default.propTypes, {
    children: _propTypes.default.node.isRequired,
    compact: _propTypes.default.bool.isRequired,
    expanded: _propTypes.default.bool,
    expandable: _propTypes.default.bool,
    onExpandedChange: _propTypes.default.func
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UISection.default.defaultProps, {
      compact: false,
      expandable: false,
      expanded: true
    });
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        compact = _this$props.compact,
        expandable = _this$props.expandable,
        expanded = _this$props.expanded,
        onExpandedChange = _this$props.onExpandedChange,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "compact", "expandable", "expanded", "onExpandedChange"]);
    return _react.default.createElement(_UISection.default, (0, _extends2.default)({}, rest, {
      className: (0, _classnames.default)('private-card', 'private-card__wrapper', {
        'private-card--compact': compact
      }, className)
    }), expandable ? renderExpandableChildren(children, expanded, onExpandedChange) : children);
  }
});

var _default = (0, _Controllable.default)(UICardWrapper, ['expanded']);

exports.default = _default;
module.exports = exports.default;